import { OrderRefundCollectionItemResponse } from '../api/responses/order-refund-collection-item.response';
import { OrderRefundCollectionItem } from '../models';

export const orderRefundCollectionItemFromResponse = (
  response: OrderRefundCollectionItemResponse,
): OrderRefundCollectionItem => {
  return new OrderRefundCollectionItem({
    number: response.number,
    status: response.status,
    cancelledAt: response.cancelledAt,
    createdAt: response.createdAt,
    type: response.type,
    refundedPrice: response.refundedPrice,
    description: response.description,
    finalizedAt: response.finalizedAt,
    invoiceNumber: response.invoice?.number,
    invoiceId: response.invoice?.id,
  });
};
